import { BurnerBaseW18, BurnerBaseW24, BurnerBaseW24Variant, CabinetColor, Drawer33Door66, EvoBaseW36, FullDoorBase, GrillBase, GrillBaseVariant, Handing, KamadoGrillBase, LynxSinkBase, SinkBase, ThreeDrawerBase, TrashPulloutBase } from '../__generated/model/index.js';
import { CabinetWidth, NO_HANDING } from '../implementations/common.js';
import { getResourceUrlHack } from '../util/resources.js';
export const MaterialSwatchMap = {
    [CabinetColor.Obsidian]: {
        color: '#282529',
        swatchName: 'Obsidian'
    },
    [CabinetColor.Glacier]: {
        color: '#e1ddd5',
        swatchName: 'Glacier'
    },
    [CabinetColor.PacificBlue]: {
        color: '#004599',
        swatchName: 'Pacific Blue'
    },
    [CabinetColor.CaliforniaPoppy]: {
        color: '#ffc117',
        swatchName: 'California Poppy'
    },
    [CabinetColor.Surf]: {
        color: '#c2eddb',
        swatchName: 'Surf'
    },
    [CabinetColor.DesertSage]: {
        color: '#939983',
        swatchName: 'Desert Sage'
    },
    [CabinetColor.Limestone]: {
        color: '#9e9c99',
        swatchName: 'Limestone'
    },
    [CabinetColor.Sierra]: {
        color: '#783e29',
        swatchName: 'Sierra'
    }
};
const coloredMaterialProperties = {
    metalness: 0.2,
    reflectivity: 1,
    roughness: 0.9,
    clearcoat: 0,
    clearcoatRoughness: 0,
    normalMapUrl: 'textures/solid-paint_Normal.jpg',
    normalScale: 0.5,
    repeatX: 80,
    repeatY: 80
};
export const StainlessMaterialProperties = {
    color: '#e7e7e7',
    metalness: 0.9,
    reflectivity: 0.5,
    clearcoat: 0,
    clearcoatRoughness: 0,
    roughness: 0.4,
    roughnessMapUrl: 'textures/Brushed_stainless_steel_png_Roughness.png',
    normalMapUrl: 'textures/Brushed_stainless_steel_png_Normal.png',
    normalScale: 1,
    repeatX: 60,
    repeatY: 60
};
export const MaterialsMap = {
    [CabinetColor.Obsidian]: {
        ...coloredMaterialProperties,
        color: '#302d31'
    },
    [CabinetColor.Glacier]: {
        ...coloredMaterialProperties,
        color: '#d5d0c5',
        reflectivity: 1.2,
        normalScale: 1.5
    },
    [CabinetColor.PacificBlue]: {
        ...coloredMaterialProperties,
        color: '#24466e',
        reflectivity: 0.7,
        metalness: 0.1,
        normalScale: 0.8
    },
    [CabinetColor.CaliforniaPoppy]: {
        ...coloredMaterialProperties,
        roughness: 0.6,
        color: '#b88700',
        normalScale: 1
    },
    [CabinetColor.Surf]: {
        ...coloredMaterialProperties,
        color: '#80a3a6',
        normalScale: 1.2
    },
    [CabinetColor.DesertSage]: {
        ...coloredMaterialProperties,
        color: '#7a7d70',
        normalScale: 1
    },
    [CabinetColor.Limestone]: {
        ...coloredMaterialProperties,
        color: '#7e7b79',
        metalness: 0.1,
        normalScale: 1.3
    },
    [CabinetColor.Sierra]: {
        ...coloredMaterialProperties,
        color: '#594339',
        reflectivity: 0.7,
        metalness: 0.1,
        normalScale: 0.8
    }
};
export const cabinetData = {
    [`${Drawer33Door66.type}_${CabinetWidth.W18}_${Handing.left}`]: {
        name: '1/3 Drawer, 2/3 Door Base 18" - LH',
        sku: 'LYNX-2DDH-18L',
        description: '1/3 Drawer, 2/3 Door Base 18" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png')
    },
    [`${Drawer33Door66.type}_${CabinetWidth.W18}_${Handing.right}`]: {
        name: '1/3 Drawer, 2/3 Door Base 18" - RH',
        sku: 'LYNX-2DDH-18R',
        description: '1/3 Drawer, 2/3 Door Base 18" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png')
    },
    [`${Drawer33Door66.type}_${CabinetWidth.W24}_${Handing.left}`]: {
        name: '1/3 Drawer, 2/3 Door Base 24" - LH',
        sku: 'LYNX-2DDH-24L',
        description: '1/3 Drawer, 2/3 Door Base 24" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png')
    },
    [`${Drawer33Door66.type}_${CabinetWidth.W24}_${Handing.right}`]: {
        name: '1/3 Drawer, 2/3 Door Base 24" - RH',
        sku: 'LYNX-2DDH-24R',
        description: '1/3 Drawer, 2/3 Door Base 24" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png')
    },
    [`${BurnerBaseW18.type}_${CabinetWidth.W18}_${Handing.left}`]: {
        name: 'Burner Base 18" - LH',
        sku: 'LYNX-BBFD-18L',
        description: 'Burner Base 18"x28.25" - Left Hinge Door',
        thumbnailUrl: undefined
    },
    [`${BurnerBaseW18.type}_${CabinetWidth.W18}_${Handing.right}`]: {
        name: 'Burner Base 18" - RH',
        sku: 'LYNX-BBFD-18R',
        description: 'Burner Base 18"x28.25" - Right Hinge Door',
        thumbnailUrl: undefined
    },
    [`${BurnerBaseW24.type}_${CabinetWidth.W24}_${BurnerBaseW24Variant.CounterTopHeight}_${Handing.left}`]: {
        name: 'Burner Base 24" - LH',
        sku: 'LYNX-BBFD-24L',
        description: 'Burner Base 24"x28.25" - Left Hinge Door',
        thumbnailUrl: undefined
    },
    [`${BurnerBaseW24.type}_${CabinetWidth.W24}_${BurnerBaseW24Variant.CounterTopHeight}_${Handing.right}`]: {
        name: 'Burner Base 24" - RH',
        sku: 'LYNX-BBFD-24R',
        description: 'Burner Base 24"x28.25" - Right Hinge Door',
        thumbnailUrl: undefined
    },
    [`${BurnerBaseW24.type}_${CabinetWidth.W24}_${BurnerBaseW24Variant.Lowered}_${Handing.top}`]: {
        name: 'Burner Base 24"',
        sku: 'LYNX-BBFD-24',
        description: 'Burner Base 24" - with Lowered Power Burner',
        thumbnailUrl: undefined
    },
    [`${EvoBaseW36.type}_${CabinetWidth.W36}_${Handing.both}`]: {
        name: 'EVO Base - 25G',
        sku: 'LYNX-EVO36-36',
        description: '36" EVO Base - EVO 25G',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/evo-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W36}_${GrillBaseVariant.Default}`]: {
        name: 'Grill Base 36"',
        sku: 'LYNX-GBFD-36',
        description: 'Grill Base 36"x28.25" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W42}_${GrillBaseVariant.Default}`]: {
        name: 'Grill Base 42"',
        sku: 'LYNX-GBFD-42',
        description: 'Grill Base 42"x28.25" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W48}_${GrillBaseVariant.Default}`]: {
        name: 'Grill Base 48"',
        sku: 'LYNX-GBFD-48',
        description: 'Grill Base 48"x28.25" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W60}_${GrillBaseVariant.Default}`]: {
        name: 'Grill Base 60"',
        sku: 'LYNX-GB3FD-60',
        description: 'Grill Base 60"x28.25" - Three Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W36}_${GrillBaseVariant.WithWarmingDrawer}`]: {
        name: 'Grill Base 36" with Warming Drawer',
        sku: 'LYNX-GBFD-36-WD',
        description: 'Grill Base 36"x28.25" - Warming Drawer',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W42}_${GrillBaseVariant.WithWarmingDrawer}`]: {
        name: 'Grill Base 42" with Warming Drawer',
        sku: 'LYNX-GBFD-42-WD',
        description: 'Grill Base 42"x28.25" - Warming Drawer',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W48}_${GrillBaseVariant.WithWarmingDrawer}`]: {
        name: 'Grill Base 48" with Warming Drawer',
        sku: 'LYNX-GBFD-48-WD',
        description: 'Grill Base 48"x28.25" - Warming Drawer',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${GrillBase.type}_${CabinetWidth.W60}_${GrillBaseVariant.WithWarmingDrawer}`]: {
        name: 'Grill Base 60" with Warming Drawer',
        sku: 'LYNX-GB3FD-60-WD',
        description: 'Grill Base 60"x28.25" - Warming Drawer',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png')
    },
    [`${KamadoGrillBase.type}_${CabinetWidth.W30}_${Handing.top}`]: {
        name: 'Kamado Grill Base 30"',
        sku: 'LYNX-CGBDD-30-OPN',
        description: 'Kamado Grill Base 30"',
        thumbnailUrl: ''
    },
    [`${FullDoorBase.type}_${CabinetWidth.W12}_${Handing.left}`]: {
        name: 'Full Door Base 12" - LH',
        sku: 'LYNX-FDH-12L',
        description: 'Full Door Base 12" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${FullDoorBase.type}_${CabinetWidth.W12}_${Handing.right}`]: {
        name: 'Full Door Base 12" - RH',
        sku: 'LYNX-FDH-12R',
        description: 'Full Door Base 12" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${FullDoorBase.type}_${CabinetWidth.W18}_${Handing.left}`]: {
        name: 'Full Door Base 18" - LH',
        sku: 'LYNX-FDH-18L',
        description: 'Full Door Base 18" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${FullDoorBase.type}_${CabinetWidth.W18}_${Handing.right}`]: {
        name: 'Full Door Base 18" - RH',
        sku: 'LYNX-FDH-18R',
        description: 'Full Door Base 18" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${FullDoorBase.type}_${CabinetWidth.W24}_${Handing.left}`]: {
        name: 'Full Door Base 24" - LH',
        sku: 'LYNX-FDH-24L',
        description: 'Full Door Base 24" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${FullDoorBase.type}_${CabinetWidth.W24}_${Handing.right}`]: {
        name: 'Full Door Base 24" - RH',
        sku: 'LYNX-FDH-24R',
        description: 'Full Door Base 24" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png')
    },
    [`${LynxSinkBase.type}_${CabinetWidth.W24}_${Handing.left}`]: {
        name: 'Full Door Sink Base 24" - LH',
        sku: 'LYNX-SBLXH-24L',
        description: 'Full Door Sink Base 24" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${LynxSinkBase.type}_${CabinetWidth.W24}_${Handing.right}`]: {
        name: 'Full Door Sink Base 24" - RH',
        sku: 'LYNX-SBLXH-24R',
        description: 'Full Door Sink Base 24" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${LynxSinkBase.type}_${CabinetWidth.W30}_${Handing.both}`]: {
        name: 'Full Door Sink Base 30"',
        sku: 'LYNX-SBLXH-30',
        description: 'Full Door Sink Base 30" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${LynxSinkBase.type}_${CabinetWidth.W36}_${Handing.both}`]: {
        name: 'Full Door Sink Base 36"',
        sku: 'LYNX-SBLXH-36',
        description: 'Full Door Sink Base 36" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${SinkBase.type}_${CabinetWidth.W24}_${Handing.left}`]: {
        name: 'Full Door Sink Base 24" - LH',
        sku: 'LYNX-SBFDH-24L',
        description: 'Full Door Sink Base 24" - Right Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${SinkBase.type}_${CabinetWidth.W24}_${Handing.right}`]: {
        name: 'Full Door Sink Base 24" - RH',
        sku: 'LYNX-SBFDH-24R',
        description: 'Full Door Sink Base 24" - Left Hinge Door',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${SinkBase.type}_${CabinetWidth.W30}_${Handing.both}`]: {
        name: 'Full Door Sink Base 30"',
        sku: 'LYNX-SBFD-30',
        description: 'Full Door Sink Base 30" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${SinkBase.type}_${CabinetWidth.W36}_${Handing.both}`]: {
        name: 'Full Door Sink Base 36"',
        sku: 'LYNX-SBFD-36',
        description: 'Full Door Sink Base 36" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${SinkBase.type}_${CabinetWidth.W48}_${Handing.both}`]: {
        name: 'Full Door Sink Base 48"',
        sku: 'LYNX-SBFD-48',
        description: 'Full Door Sink Base 48" - Two Full Doors',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-sink-base.png')
    },
    [`${ThreeDrawerBase.type}_${CabinetWidth.W18}_${NO_HANDING}`]: {
        name: '3-Drawer Base 18"',
        sku: 'LYNX-3D-18',
        description: '3-Drawer Base 18"',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/3-drawer-base.png')
    },
    [`${ThreeDrawerBase.type}_${CabinetWidth.W24}_${NO_HANDING}`]: {
        name: '3-Drawer Base 24"',
        sku: 'LYNX-3D-24',
        description: '3-Drawer Base 24"',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/3-drawer-base.png')
    },
    [`${TrashPulloutBase.type}_${CabinetWidth.W18}_${Handing.top}`]: {
        name: 'Full Door Trash Pullout Base 18"',
        sku: 'LYNX-PO-18',
        description: 'Full Door Trash Pullout Base 18" - 1 Bin',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/trash-pullout-base.png')
    },
    [`${TrashPulloutBase.type}_${CabinetWidth.W24}_${Handing.top}`]: {
        name: 'Full Door Trash Pullout Base 24"',
        sku: 'LYNX-PO-24',
        description: 'Full Door Trash Pullout Base 24" - 2 Bins',
        thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/trash-pullout-base.png')
    }
};
export const cabinetDataBySku = Object.entries(cabinetData).reduce((acc, [key, item])=>{
    acc[item.sku] = {
        ...item,
        key
    };
    return acc;
}, {});
export const defaultCountertopData = {
    scale: {
        depth: {
            zero: 25.75 * 25.4,
            one: 34.714 * 25.4
        },
        width: {
            zero: 18 * 25.4,
            one: 42 * 25.4
        }
    }
};
const sedonaBurnerCountertopData = {
    scale: {
        depth: {
            zero: 25.75 * 25.4,
            one: 31.75 * 25.4
        },
        // not used
        width: {
            zero: 0,
            one: 0
        }
    }
};
export const customCountertopData = {
    scale: {
        depth: {
            zero: 28.75 * 25.4,
            one: 34.75 * 25.4
        },
        // not used
        width: {
            zero: 0,
            one: 0
        }
    }
};
const countertopData = {
    COUNTERTOP: defaultCountertopData,
    COUNTERTOP_BURNER_SINGLE: customCountertopData,
    COUNTERTOP_BURNER_DOUBLE: customCountertopData,
    COUNTERTOP_BURNER_LSB501: sedonaBurnerCountertopData,
    COUNTERTOP_BURNER_LSB502: sedonaBurnerCountertopData,
    COUNTERTOP_BURNER_POWER: customCountertopData,
    COUNTERTOP_EVO_AFFINITY_25: customCountertopData,
    COUNTERTOP_EVO_AFFINITY_30: customCountertopData,
    COUNTERTOP_GRIDDLE: customCountertopData,
    COUNTERTOP_GRILL_30: customCountertopData,
    COUNTERTOP_GRILL_36: customCountertopData,
    COUNTERTOP_GRILL_42: customCountertopData,
    COUNTERTOP_GRILL_54: customCountertopData,
    COUNTERTOP_SINK: customCountertopData
};
export const getCountertopData = (modelObjectName)=>countertopData[modelObjectName] ?? defaultCountertopData;
export var ToeKickObjectName;
(function(ToeKickObjectName) {
    ToeKickObjectName["TOE_KICK_VENT_60IN"] = "TOE_KICK_VENT_60IN";
    ToeKickObjectName["TOE_KICK_VENT_48IN"] = "TOE_KICK_VENT_48IN";
    ToeKickObjectName["TOE_KICK_VENT_42IN"] = "TOE_KICK_VENT_42IN";
    ToeKickObjectName["TOE_KICK_VENT_36IN"] = "TOE_KICK_VENT_36IN";
    ToeKickObjectName["TOE_KICK_VENT_30IN"] = "TOE_KICK_VENT_30IN";
    ToeKickObjectName["TOE_KICK_VENT_24IN"] = "TOE_KICK_VENT_24IN";
    ToeKickObjectName["TOE_KICK_VENT_18IN"] = "TOE_KICK_VENT_18IN";
    ToeKickObjectName["TOE_KICK"] = "TOE_KICK";
})(ToeKickObjectName || (ToeKickObjectName = {}));
const toeKickData = {
    ["TOE_KICK_VENT_60IN"]: {
        scaleZero: 60 * 25.4,
        scaleOne: 72 * 25.4
    },
    ["TOE_KICK_VENT_48IN"]: {
        scaleZero: 48 * 25.4,
        scaleOne: 60 * 25.4
    },
    ["TOE_KICK_VENT_42IN"]: {
        scaleZero: 42 * 25.4,
        scaleOne: 54 * 25.4
    },
    ["TOE_KICK_VENT_36IN"]: {
        scaleZero: 36 * 25.4,
        scaleOne: 48 * 25.4
    },
    ["TOE_KICK_VENT_30IN"]: {
        scaleZero: 30 * 25.4,
        scaleOne: 42 * 25.4
    },
    ["TOE_KICK_VENT_24IN"]: {
        scaleZero: 24 * 25.4,
        scaleOne: 36 * 25.4
    },
    ["TOE_KICK_VENT_18IN"]: {
        scaleZero: 18 * 25.4,
        scaleOne: 30 * 25.4
    },
    ["TOE_KICK"]: {
        scaleZero: 17.6 * 25.4,
        scaleOne: 42 * 25.4
    }
};
export const getToeKickData = (modelObjectName)=>toeKickData[modelObjectName];

//# sourceMappingURL=cabinets.js.map